import { type CarrierDef } from '../common.js'

const credentialTypes = [
  'business-unit-id',
  'customer-id',
  'cost-center-code',
  'rating-business-unit-id',
  'rating-customer-id',
  'rating-cost-center-code',
  'requesting-company',
  'customer-code',
  'billing-number',
  'bill-to-code',
] as const

export type cevvCredType = (typeof credentialTypes)[number]
export const cevv: CarrierDef<cevvCredType> = {
  name: 'CEVA LOGISTICS US INC',
  scac: 'cevv',
  credentialTypes,
  engineLayers: ['rating', 'pickup', 'tracking', 'profinder'],
  credentialConfig: {
    'business-unit-id': { customerIdentifier: true },
    'customer-id': { customerIdentifier: true },
    'cost-center-code': { customerIdentifier: true },
    'requesting-company': { customerIdentifier: true },
    'customer-code': { customerIdentifier: true },
    'billing-number': { customerIdentifier: true },
    'bill-to-code': { customerIdentifier: true },
  },
  ltlServices: [
    {
      id: 'standard',
      name: 'Standard',
    },
    {
      id: 'threshold',
      name: 'Threshold',
    },
    {
      id: 'deferred',
      name: 'Deferred',
    },
  ],
}
